import { useCurrentSiteId } from '@hotjar/site';
import { useTierForGate, useGate } from '@hotjar/allowances';
import { AccentColorSection } from './AccentColorSection';
import type { AccentColorSectionProps } from './AccentColorSection';

const GATE = 'feedback.appearance.accent_color';

export function AccentColorSectionGate(
  props: Omit<AccentColorSectionProps, 'upsellPlan | hasRequiredPlan'>,
): JSX.Element {
  const currentSiteId = useCurrentSiteId();
  const context = {
    type: 'site',
    id: currentSiteId,
  } as const;
  const hasAccentColorGate = useGate(GATE, context);
  const tierForAccentColor = useTierForGate(GATE, context);

  return (
    <AccentColorSection
      {...props}
      upsellPlan={tierForAccentColor}
      hasRequiredPlan={hasAccentColorGate}
    />
  );
}
